import { render, staticRenderFns } from "./HistorialTableActions.vue?vue&type=template&id=28a08bda"
import script from "./HistorialTableActions.vue?vue&type=script&lang=js"
export * from "./HistorialTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports